import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import { API_BASE_URL } from '../config';

function HomePage() {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [groupedDepartments, setGroupedDepartments] = useState({});
  const [developerMode, setDeveloperMode] = useState(false);
  const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    // 利用に関する注意事項を表示
    alert('注意：このシステムの利用結果はあくまで参考情報です．\n正式な卒業要件の確認は必ず教務課で行ってください．\n利用は自己責任でお願いいたします．');

    const fetchDepartments = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/departments`);
        const data = await response.json();
        setDepartments(data);

        // 学部ごとに学科をグループ化
        const grouped = data.reduce((acc, dept) => {
          if (!acc[dept.faculty_name]) {
            acc[dept.faculty_name] = [];
          }
          acc[dept.faculty_name].push(dept);
          return acc;
        }, {});
        setGroupedDepartments(grouped);
      } catch (error) {
        console.error('Error fetching departments:', error);
      }
    };

    fetchDepartments();
  }, []);

  const handleDepartmentSelect = (deptAbbr) => {
    if (deptAbbr === 'CS') {
      navigate('/courses', { state: { developerMode } });
    }
  };

  const handleTitleClick = () => {
    setClickCount(prev => prev + 1);
    if (clickCount === 8 ){
      setDeveloperMode(true);
      alert('開発者モードが有効になりました');
      setClickCount(0);
    }
  };

  return (
    <div className="home-container">
      <h1 onClick={handleTitleClick} style={{ cursor: 'pointer' }}>
        TMU 卒業要件確認システム
        {developerMode && <span style={{ fontSize: '0.5em', color: '#666' }}> (開発者モード)</span>}
      </h1>
      <h2 style={{ marginTop: '0.25em', fontSize: '1rem', color: '#777', fontWeight: 'normal' }}>
        プレリリース (v0.1.1)
      </h2>
      {Object.entries(groupedDepartments).map(([facultyName, facultyDepts]) => (
        <div key={facultyName} className="faculty-section">
          <h2>{facultyName}</h2>
          <div className="department-buttons">
            {facultyDepts.map((dept) => {
              const isCS = dept.department_abbr === 'CS';
              return (
                <button
                  key={dept.department_abbr}
                  className="department-button"
                  onClick={() => handleDepartmentSelect(dept.department_abbr)}
                  disabled={!isCS}
                >
                  {dept.department_name}
                  {isCS ? '（選択可能）' : '（開発中）'}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export default HomePage;